import Base from './base'

export type TokenPayload = {
  token: string
  utcNow: number
  isSsoAdmin: boolean
}

export default class IntegrationIframeToken extends Base {
  getIntegrationIframeTokenPayload(): Promise<TokenPayload> {
    return this.api.post('tokens', { permissions: [] })
  }
}
